import { css } from '@emotion/react';
export const iconStaticStyle = css({
    flexShrink: 0,
});
